export default __webpack_public_path__ + "static/media/pouchnation-footer.d94af77b.svg";